import { useEffect, useState } from "react";
import {
  getHousingProjects,
  getHousingProjectsByCity,
  getBuilderName,
  getRowsByCityProjectBuilder
} from "./util/util";
import "./App.css"


function App() {
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");

  const [builders, setBuilders] = useState([]);
  const [selectedBuilder, setSelectedBuilder] = useState("");

  const [rows, setRows] = useState([]);
  const [viewRow, setViewRow] = useState(null);
  const [showResult, setShowResult] = useState(false);

  const [loading, setLoading] = useState(true);

  /* ================= LOAD CITIES ================= */
  useEffect(() => {
    async function loadCities() {
      try {
        setLoading(true);
        const result = await getHousingProjects();
        setCities(result);
      } finally {
        setLoading(false);
      }
    }
    loadCities();
  }, []);

  /* ================= LOAD PROJECTS ================= */
  useEffect(() => {
    if (!selectedCity) {
      setProjects([]);
      setSelectedProject("");
      return;
    }

    async function loadProjects() {
      try {
        setLoading(true);
        const result = await getHousingProjectsByCity(selectedCity);
        setProjects(result);
      } finally {
        setLoading(false);
      }
    }

    loadProjects();
  }, [selectedCity]);

  /* ================= LOAD BUILDERS ================= */
  useEffect(() => {
    if (!selectedProject) {
      setBuilders([]);
      setSelectedBuilder("");
      return;
    }

    async function loadBuilders() {
      try {
        setLoading(true);
        const result = await getBuilderName(selectedProject);
        setBuilders(result);
      } finally {
        setLoading(false);
      }
    }

    loadBuilders();
  }, [selectedProject]);

  /* ================= SUBMIT ================= */
  const handleSubmit = async () => {
    if (!selectedCity || !selectedProject || !selectedBuilder) {
      alert("Please select all dropdowns");
      return;
    }

    try {
      setLoading(true);
      const result = await getRowsByCityProjectBuilder(
        selectedCity,
        selectedProject,
        selectedBuilder
      );
      setRows(result);
      setShowResult(true);
    } finally {
      setLoading(false);
    }
  };

  /* ================= CLEAR ================= */
  const handleClear = () => {
    setSelectedCity("");
    setSelectedProject("");
    setSelectedBuilder("");
    setProjects([]);
    setBuilders([]);
    setRows([]);
    setViewRow(null);
    setShowResult(false);
  };

 return (
  <div className={`app-container ${loading ? "disabled" : ""}`}>

    {/* LOADER */}
    {loading && (
      <div className="loader-overlay">
        <div className="loader-box">Loading...</div>
      </div>
    )}

    {/* TITLE */}
    <div className="form-title">
      Please select PLACE / CITY (OR) PROJECT NAME (OR) BUILDER NAME
    </div>

    {/* CITY */}
    <label>Select Place / City*</label>
    <select
      value={selectedCity}
      onChange={(e) => setSelectedCity(e.target.value)}
    >
      <option value="">Select City</option>

      {cities.map((city) => (
        <option key={city} value={city}>
          {city}
        </option>
      ))}
    </select>

    <div className="or-text">(OR)</div>

    {/* PROJECT */}
    <label>Select Project Name</label>
    <select
      value={selectedProject}
      onChange={(e) => setSelectedProject(e.target.value)}
      disabled={!selectedCity}
    >
      <option value="">Select Project</option>

      {projects.map((project) => (
        <option key={project} value={project}>
          {project}
        </option>
      ))}
    </select>

    <div className="or-text">(OR)</div>

    {/* BUILDER */}
    <label>Select Builder Name</label>
    <select
      value={selectedBuilder}
      onChange={(e) => setSelectedBuilder(e.target.value)}
      disabled={!selectedProject}
    >
      <option value="">Select Builder</option>

      {builders.map((builder) => (
        <option key={builder} value={builder}>
          {builder}
        </option>
      ))}
    </select>

    {/* BUTTONS */}
    <div className="button-row">
      <button
        className="btn-primary"
        disabled={
          !(selectedCity && selectedProject && selectedBuilder)
        }
        onClick={handleSubmit}
      >
        Submit
      </button>

      <button
        className="btn-secondary"
        onClick={handleClear}
      >
        Clear
      </button>
    </div>

    {/* TABLE */}
    {showResult && rows.length > 0 && (
      <table>
        <thead>
          <tr>
            <th>Sr.No.</th>
            <th>City / Place</th>
            <th>Project Name</th>
            <th>Builder Name</th>
            <th>View Details</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id}>
              <td>{i + 1}</td>
              <td>{row.city}</td>
              <td>{row.projectName}</td>
              <td>{row.builderName}</td>

              <td>
                <button
                  className="btn-link"
                  onClick={() => setViewRow(row)}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}

    {/* MODAL */}
    {viewRow && (
      <div className="modal-overlay">
        <div className="modal-box">

          <h3>PROJECT DETAILS</h3>

          <table>
            <tbody>
              <tr>
                <th>Builder Name</th>
                <td>{viewRow.builderName}</td>

                <th>Builder Address</th>
                <td>{viewRow.builderAddress}</td>
              </tr>

              <tr>
                <th>Project Name</th>
                <td>{viewRow.projectName}</td>

                <th>Project Address</th>
                <td>{viewRow.projectAddress}</td>
              </tr>

              <tr>
                <th>Project Status</th>
                <td>{viewRow.projectStatus}</td>

                <th>Approval Date</th>
                <td>{viewRow.approvalDate}</td>
              </tr>
            </tbody>
          </table>

          <div className="modal-actions">
            <button
              className="btn-danger"
              onClick={() => setViewRow(null)}
            >
              Close
            </button>
          </div>

        </div>
      </div>
    )}

  </div>
);
}

export default App;
